import React, { useMemo } from 'react';
import classNames from 'classnames';

import { PaginationLinks } from '../../../components';
import ProductCard from '../../../components/Cobe/ProductCard/ProductCard';

import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings = [],
    pagination,
    search,
    setActiveListing,
    isMapVariant = true,
    listingTypeParam,
    children,
  } = props;


  const classes = classNames(rootClassName || css.root, className);

  const pageName = listingTypeParam
    ? 'SearchPageWithListingType'
    : 'SearchPage';

  const currentPage = pagination?.page || 1;

  // Memoized image sizes
  const renderSizes = useMemo(() => {
    if (isMapVariant) {
      return [
        '(max-width: 767px) 100vw',
        '(max-width: 1023px) 50vw',
        '(max-width: 1920px) 31vw',
        '21vw',
      ].join(', ');
    }

    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      '(max-width: 1439px) 26vw',
      '(max-width: 1920px) 18vw',
      '14vw',
    ].join(', ');
  }, [isMapVariant]);

  const paginationLinks =
    pagination?.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={pageName}
        pagePathParams={{ listingType: listingTypeParam }}
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  return (
    <div className={classes}>
      <div
        className={
          isMapVariant
            ? css.listingCardsMapVariant
            : css.listingCards
        }
      >
        {listings
          .filter(Boolean)
          .map((listing, index) => {
            const uuid = listing?.id?.uuid;
            if (!uuid) return null;

            const hoverHandlers = setActiveListing
              ? {
                  onMouseEnter: () =>
                    setActiveListing(listing.id),
                  onMouseLeave: () =>
                    setActiveListing(null),
                }
              : {};

            return (
              <div
                key={uuid}
                className={css.listingCard}
                {...hoverHandlers}
              >
                <ProductCard
                  product={listing}
                  isSearchPage
                  sizes={renderSizes}
                />
              </div>
            );
          })}

        {children}
      </div>

      {paginationLinks}
    </div>
  );
};

export default React.memo(SearchResultsPanel);